// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'
import Axios from '@/assets/js/axios.js';
//引入图表插件
import echarts from 'echarts'
import '@/assets/css/index.scss'
import '@/assets/css/custom.css'
import '@/assets/css/theme.scss'
import '@/assets/font/iconfont.css'
import '@/assets/font/font.css';
import '@/assets/iconfont/iconfont.css';
import '@/assets/newicon/iconfont.css';

// 引入视频插件样式
import 'video.js/dist/video-js.css'
import colorObj from '@/assets/js/color-configure.js'
Vue.prototype.$colorObj = colorObj;

import aniData from '@/assets/json/animate.json';
import store from './store';

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import '@/assets/css/my-theme.scss';
import '@/assets/css/trans.scss';
import MQTTWrapper from "@/assets/js/mqttHandler";
Vue.prototype.$mqtt = new MQTTWrapper();


Vue.use(ViewUI);
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.$Axios = Axios;

/* eslint-disable no-new */

Vue.prototype.$aniData = aniData;


// 指定jquery
window.$JQ = $;
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js